(function() {
    'use strict';
a3_cabin_reports.controller('ASSFReportCtrl',ASSFReportCtrl);
                            
    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name ASSFReportCtrl
    * @description 
    *   The aircraft security report page
    * @ngInject
    */
    function ASSFReportCtrl($scope, $routeParams, $location, SettingsMain, FlightFactory,$timeout, 
                            ASSFReportFactory, ASSFSyncInfoFactory, UserFactory, AircaftPositionsFactory, $uibModal) {
        
        var flightId = $routeParams.flightId;
        SettingsMain.setEditingPage("assfReport");
        $scope.user = UserFactory.getUser();
        $scope.sendClicked = sendClicked;
        $scope.saveClicked = saveClicked;
        $scope.saveDraftClicked = saveDraftClicked;
        $scope.discard = discard;
        $scope.IsCompleted = IsCompleted;
        $scope.assfReport = null;
        $scope.flight = null;
        $scope.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 1
        };

        $scope.infosaveaction = false;
        $scope.infosaveactiontype = null;  
        $scope.infoSaveOperation = infoSaveOperation;
        $scope.clearSignature = clearSignature;
        $scope.checkForCommanderSignature = checkForCommanderSignature; 
        $scope.showCommanderSignature = false;
        $scope.openSignatureModal = openSignatureModal;

        $scope.panels = {
            allInOne: {
                open: true
            }
        };

        if (flightId == "temp") {
            $scope.assfReport = ASSFReportFactory.getTempAssessment();
            $scope.flight = FlightFactory.getFlightFromStorage(assfReport.flightId);
            SettingsMain.setEditingPage(null);
		} else {
            $scope.flight = FlightFactory.getFlightFromStorage(flightId);
            $scope.assfReport = ASSFReportFactory.getAssfReportFromStorage( $scope.flight.FlightId );
            
            if(!$scope.assfReport){
                $scope.assfReport = ASSFReportFactory.getNewAssfReport();
            }
		}

        $scope.assfReport.commanderSignature = $scope.assfReport.commanderSignature || null;
        $scope.assfReport.cabinCrewSignature = $scope.assfReport.cabinCrewSignature || null;
        $scope.assfReport.flightCrewSignature = $scope.assfReport.flightCrewSignature || null;
        $scope.assfReport.groundServiceProviderSignature = $scope.assfReport.groundServiceProviderSignature || null;

        $scope.openSignatureModal = openSignatureModal;
        $scope.signatureButtonClass = signatureButtonClass;

         function signatureButtonClass(role) {
      // role: "Commander", "CabinCrew", "FlightCrew", "GroundServiceProvider"
      var field = role.charAt(0).toLowerCase() + role.slice(1) + 'Signature';
      // π.χ. "commanderSignature"
      return $scope.assfReport[field] 
        ? 'btn btn-success' 
        : 'btn btn-primary';
    }

        autofillFields($scope.assfReport);
  
        $scope.cabinCrew = $scope.flight.crew.filter(function(member) {
            return member.position === 'SA' || member.position === 'FA';
        });
        $scope.flightCrew = $scope.flight.crew.filter(function(member) {
            return member.position === 'CP' || member.position === 'FO';    
        });
        $scope.cpCrew = $scope.flight.crew.filter(function(member) {
            return member.position === 'CP';    
        });
        var selectedCabinCrew = $scope.cabinCrew.find(function(c) {
            return c.name.trim() === $scope.user.name.trim();
        });
        if (!$scope.assfReport.cabinCrewName && selectedCabinCrew) {
            $scope.assfReport.cabinCrewName = selectedCabinCrew.name.trim();
        }
        var selectedFlightCrew = $scope.flightCrew.find(function(c) {
            return c.name.trim() === $scope.user.name.trim();
        });
        if (!$scope.assfReport.flightCrewName && selectedFlightCrew) {
            $scope.assfReport.flightCrewName = selectedFlightCrew.name.trim();
        }

        //Get the active version of the assf report and set it to the assf report. 
        var assfInfo = ASSFSyncInfoFactory.getASSFInfo();
        if(assfInfo && assfInfo.ActiveVersion && assfInfo.ActiveVersion.Notes){
            $scope.reportNotes = assfInfo.ActiveVersion.Notes;
        }
         
        // Update the area categories if they are not set
        if(!$scope.assfReport.areaCategories || $scope.assfReport.areaCategories.length === 0){
            if(assfInfo && assfInfo.ActiveVersion && assfInfo.ActiveVersion.AreaCategories){
                $scope.assfReport.areaCategories = angular.copy(assfInfo.ActiveVersion.AreaCategories);
            }
        }

        $scope.getNowTimeUTC = getNowTimeUTC;
        $scope.searchCompletedTimeChanged = searchCompletedTimeChanged;
        //var hasSearchCompletedTime = false;

        // Initialize the time control with UTC values
        $scope.searchCompletedTime = { 
            time: $scope.assfReport.searchCompleted ? 
                moment($scope.assfReport.searchCompleted).utc().toDate() : 
                null,
            timeChanged: function(newVal) {
                if (!newVal) return;
                
                // Convert local input time to UTC 
                const localTime = moment(newVal);
                const utcTime = moment.utc()
                    .hours(localTime.hours())
                    .minutes(localTime.minutes());
                
                $scope.assfReport.searchCompleted = utcTime.toDate();
                // Force display of UTC time
                $scope.searchCompletedTime.time = utcTime.toDate();
            }
        };

        function openSignatureModal(signatureType) {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/Dialogs/dlgAssfSignature.html',
                controller: 'AssfSignatureCtrl',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                reportData: function() {
                    return $scope.assfReport;
                },
                signatureType: function() {
                    return signatureType;
                }
        }
      });

      modalInstance.result.then(function() {
        saveDraftClicked(true);
      });
    }

    function saveDraftClicked(notShowFeedback) {
      $scope.assfReport.status = 'Draft';
      ASSFReportFactory.setAssfReportToStorage($scope.assfReport);
      ASSFReportFactory.updateFlightAssfStatus($scope.assfReport);
      if (!notShowFeedback) {
        infoSaveOperation('Draft');
      }
      SettingsMain.setEditingPage(null);
      ASSFReportFactory.clearTempAssfReport();
    }


        function clearSignature(type) {
            if(type === 'FlightCrew') {
                $scope.assfReport.flightCrewSignature = null;
            }
            else if(type === 'Commander') {
                $scope.assfReport.commanderSignature = null;
            }
            else if(type === 'CabinCrew') {
                $scope.assfReport.cabinCrewSignature = null;
            }
            else if(type === 'GroundServiceProvider') {
                $scope.assfReport.groundServiceProviderSignature = null;
            }
		}

        $scope.searchCompletedDate = {
            value: $scope.assfReport.searchCompleted ? 
                moment($scope.assfReport.searchCompleted).utc().toDate() : 
                null,
            set: function(newVal) {
                if (!newVal) {
                    $scope.assfReport.searchCompleted = null;
                    $scope.searchCompletedTime.time = null;
                    return;
                }
        
                // Convert to UTC and preserve existing time if any
                const newDate = moment(newVal).utc();
                if ($scope.searchCompletedTime.time) {
                    const currentTime = moment($scope.searchCompletedTime.time).utc();
                    newDate.hours(currentTime.hours());
                    newDate.minutes(currentTime.minutes());
                }
        
                const utcDate = newDate.toDate();
                $scope.assfReport.searchCompleted = utcDate;
                $scope.searchCompletedTime.time = utcDate;
            }
        };
    
        // Update the applicability rules if they are not set
        function searchCompletedTimeChanged() {
            if (!$scope.searchCompletedTime.time) {
                return;
            }
            // Keep everything in UTC
            const newTime = moment.utc($scope.searchCompletedTime.time);
            const currentDate = $scope.assfReport.searchCompleted ? 
                moment(newTime) : 
                moment.utc();
            
            currentDate.hours(newTime.hours());
            currentDate.minutes(newTime.minutes());
            
            $scope.assfReport.searchCompleted = currentDate.toDate();
            $scope.searchCompletedDate.value = currentDate.toDate();
        }

        function getNowTimeUTC() {
            // Get current UTC time
            const utcNow = moment.utc();
            // Set UTC time to all controls
            $scope.searchCompletedTime.time = utcNow.toDate().toUTC();
            $scope.searchCompletedDate.value = utcNow.toDate().toUTC();
            $scope.assfReport.searchCompleted = utcNow.toDate().toUTC();
            var notShowFeedback = true;
            saveDraftClicked(notShowFeedback);
        }
        
        $scope.allAreasSelected = function() {
            if(!$scope.assfReport || !$scope.assfReport.areaCategories) return false;

            return $scope.assfReport.areaCategories.every(function (x) {
                var areas = Array.isArray(x.SearchAreas) ? x.SearchAreas : [];
                return areas.length > 0 && areas.every(function (a) {
                    return !!a.Checked;
                });
            });
        };

        /**
         * Evaluate if this ASSF Report is valid and ready to send
         * @memberof ASSFReportCtrl 
         * @param {object} assfReport The ASSF Report
         * @returns {boolean} isCompleted
         */
		function IsCompleted() {

            if(!$scope.assfReport){
                return false;
            }
			
            // Not applicable reports are considered complete
            if ($scope.assfReport.notApplicable) {
                return true;
            }

            const hasRequiredSignatures = Boolean(
            // If Commander signature is required (i.e. showCommanderSignature is true), it must have name+sig
            (!$scope.showCommanderSignature || 
                ($scope.assfReport.commanderSignature && $scope.assfReport.commanderName))
                // Cabin‐Crew must always have name+signature
                && $scope.assfReport.cabinCrewSignature && $scope.assfReport.cabinCrewName
                // Ground‐Service must always have name+signature
                && $scope.assfReport.groundServiceProviderSignature && $scope.assfReport.groundServiceProviderName
               // Flight Crew: either no name at all, or (if name is set) then signature must also be set
                && (!$scope.assfReport.flightCrewName || $scope.assfReport.flightCrewSignature)
            );

            // Search completion must be marked
            const searchCompleted =  Boolean($scope.assfReport.searchCompleted instanceof Date 
                                            &&  !isNaN($scope.assfReport.searchCompleted));
            if ($scope.assfReport && typeof $scope.assfReport.searchCompleted === 'string') {
                $scope.assfReport.searchCompleted = new Date($scope.assfReport.searchCompleted);
            }

            const allAreasSelected = $scope.allAreasSelected();

            return hasRequiredSignatures && searchCompleted && allAreasSelected;
		}

        function clearSignature(type) {
            if(type === 'FlightCrew') {
                $scope.assfReport.flightCrewSignature = null;
            }
            else if(type === 'Commander') {
                $scope.assfReport.commanderSignature = null;
            }
            else if(type === 'CabinCrew') {
                $scope.assfReport.cabinCrewSignature = null;
            }
            else if(type === 'GroundServiceProvider') {
                $scope.assfReport.groundServiceProviderSignature = null;
            }
		}

        /**
         * Save the assf report As Draft
         * @memberof ASSFReportCtrl 
         * @param {object} assf report
         */
        function sendClicked ()
        {
            saveClicked($scope.assfReport);
            //Change the double utc conversion to a single one (UI issue with UTC dates)
            $scope.assfReport.searchCompleted = moment.utc($scope.assfReport.searchCompleted).local().toDate();
            //todo: send the report to api, get the response message and show it to the user
            ASSFReportFactory.sendReport($scope.assfReport)
            .then(res => handleSubmitResponse(res));
            
        }
        function handleSubmitResponse(res) {
            $scope.assfReport.status = "Stored";
            saveReport($scope.assfReport);
            infoSaveOperation($scope.assfReport.status);
            $timeout(function(){
                $location.path('/flightinfo/'+ $scope.flight.FlightId);
            },5000);
        }

        /**
         * Save the assf report As Completed
         * @memberof ASSFReportCtrl 
         * @param {object} assfForm The assf report
         */
		function saveClicked() {
			$scope.assfReport.status = 'Completed'
			saveReport($scope.assfReport);
            infoSaveOperation($scope.assfReport.status);
			SettingsMain.setEditingPage(null); 
			ASSFReportFactory.clearTempAssfReport();
		}

        /**
         * Discard all the changes on the assf form that are not saved
         * @memberof ASSFReportCtrl 
         */
        function discard(){
            SettingsMain.setEditingPage(null);
            $scope.assfReport = ASSFReportFactory.getAssfReportFromStorage( $scope.flight.FlightId );
            infoSaveOperation('discard');
        }

        /**
         * Save the ASSF Report 
         * @memberof ASSFReportCtrl 
         * @param {object} assfForm The Cabin Crew Feedback
         */
		function saveReport(assfForm) {
            autofillFields(assfForm);

			ASSFReportFactory.setAssfReportToStorage(assfForm); 
			ASSFReportFactory.updateFlightAssfStatus(assfForm); 
		}

        function autofillFields(assfForm) {
            $scope.flight.aircraftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId($scope.flight.FlightId);

            if(assfForm.authorId == null){
                assfForm.authorId = $scope.user.id;
            }
            assfForm.submissionTimestamp = moment.utc().toDate();;
            assfForm.flightId = $scope.flight.FlightId;
            assfForm.flightNumber = $scope.flight.FlightNo;
            assfForm.flightDate = $scope.flight.FlightDate;
            assfForm.flightOrigin = $scope.flight.Departure;
            assfForm.commanderName = $scope.flight.crew.find(function(member) {
                    return member.position === 'CP';    
                }).name;
            if($scope.flight.aircraftPositions){
                assfForm.previousFlightOrigin = $scope.flight.aircraftPositions.PreviousStation;

            }
            if (assfInfo && assfInfo.ActiveVersion) {
            assfForm.formVersionId = assfInfo.ActiveVersion.Id;
            } else {
            assfForm.formVersionId = null;
            }

            if($scope.flight.assfReport && $scope.flight.assfReport.isRequired){
                assfForm.isRequired = $scope.flight.assfReport.isRequired;
                
                if($scope.flight.assfReport.isRequired == true && assfForm.notApplicable == true){
                    assfForm.isRequired = false;
                    $scope.flight.assfReport.isRequired = false;
                    //Update flight status in LS
                    ASSFReportFactory.updateFlightAssfStatus(assfForm);
                }
            }

            //assfForm.isRequired = $scope.flight.assfReport.isRequired !== undefined && $scope.flight.assfReport.isRequired !== null ? $scope.flight.assfReport.isRequired : false;
        }
        /**
         * Display a  successful save message according to the save status 
         * @memberof ASSFReportCtrl
         * @param {string} state  the state of the selected assf report
         */
        function infoSaveOperation(state){
            if(state=='Completed'){
                    $scope.infosaveactiontype = state;
                    $scope.infosaveaction = true;
            }else if(state=='Draft'){
                    $scope.infosaveactiontype = state;
                    $scope.infosaveaction = true
            }else if(state=='discard'){
                    $scope.infosaveactiontype = state;
                    $scope.infosaveaction = true
            }
            else if (state=='Stored'){
                    $scope.infosaveactiontype = state;
                    $scope.infosaveaction = true
            }
           
            //hide the message after 5 seconds
            $timeout(function(){
                        $scope.infosaveaction = false;
            },5000);
		}

        function checkForCommanderSignature(){
            var isInList = $scope.cpCrew.find(function(crewMember) {
                return crewMember.name === $scope.assfReport.flightCrewName;
            });
            if(!isInList){
                $scope.showCommanderSignature = true;
            }else{
                $scope.showCommanderSignature = false;
            }
        };


        // Check if all areas in a category are selected
        $scope.isAllSelected = function(category) {
            if (!category.SearchAreas || category.SearchAreas.length === 0) {
                return false;
            }
            return category.SearchAreas.every(function(area) {
                return area.Checked;
            });
        };

        // Check if some (but not all) areas in a category are selected
        $scope.isPartiallySelected = function(category) {
            if (!category.SearchAreas || category.SearchAreas.length === 0) {
                return false;
            }
            var checkedCount = category.SearchAreas.filter(function(area) {
                return area.Checked;
            }).length;
            return checkedCount > 0 && checkedCount < category.SearchAreas.length;
        };

        // Toggle all areas in a category
        $scope.toggleSelectAll = function(category) {
            var shouldCheck = !$scope.isAllSelected(category);
            category.SearchAreas.forEach(function(area) {
                area.Checked = shouldCheck;
            });
        };

	}

})();